export default {
    USER: 'Käyttäjä',
    LOGIN: 'Kirjaudu',
    LANG_FI: 'Suomi',
    LANG_EN: 'Englanti',
    CHOOSE_LANG: 'Valitse kieli',

    TOOLS: 'Työkalut',
    DASHBOARD: 'Yleiskatsaus',
    PICK: 'Poiminta',
    GROUPS: 'Ryhmät',
    RANKING_LISTS: 'Ranking-listat',
    CHANGE_LOG: 'Muutostapahtumat',

    CHOOSE_FEED_CONTENT: 'Valitse syötteen sisältö',
    SHOW_MORE: 'Näytä lisää',
    SHOW_LESS: 'Näytä vähemmän',
    HIDE: 'Piilota',
    NEWS: 'Uutiset',
    STOCK_NEWS: 'Pörssitiedotteet',
    PRESS_NEWS: 'Lehdistötiedotteet',
    RECENT_NEWS: 'Uusimmat uutiset',
    SOCIAL_MEDIA: 'Sosiaalinen media',
    JOBS: 'Työpaikkailmoitukset',
    COMPANY_EVENTS: 'Yritystapahtumat',
    APPOINTMENTS: 'Nimitysuutiset',
    MODIFIED: 'muokattu',
    PUBLISHED: 'julkaistu',
    COMPANIES: 'yritykset',
    EMPTY: 'Tyhjennä',
    SEARCH: 'Hae',
    LATEST_STATEMENT: 'Viimeisin tilikausi',
    CONTENT_FOR_COMPANY_NOT_FOUND:
        'Yritykselle ei löytynyt hakemiasi julkaisuja.',

    // FRONT PAGE
    DEFAULT_COMPANY_FP: 'Koko kanta',
    INDUSTRIES_FP: 'Toimialat',
    KEY_FIGURES_GRAPH_TITLE_FP: 'Tunnusluvut \u2014 Kaikki yritykset',
    GRAPH_INFO_LARGE_SAMPLES:
        'Graafissa esitetään valitun tunnusluvun mediaani graafissa esiintyvästä joukosta. ' +
        'Voit vaihtaa graafissa esitettävää tunnuslukua alasvetovalikosta oikeassa reunassa.',

    // INDUSTRY TAB
    CHOOSE_INDUSTRY: 'Valitse toimiala',

    // LOGIN PAGE
    LOGIN_ACTION: 'Kirjaudu sisään',
    USERNAME: 'Käyttäjätunnus',
    PASSWORD: 'Salasana',
    FORGOT_PASSWORD: 'Salasana unohtunut?',
    NOT_USER_YET: 'Etkö ole vielä Analysaattorin käyttäjä?',
    ORDER_SERVICE: 'Tilaa palvelu käyttöösi',
    CONTACT: 'Ota yhteyttä',

    // COMPANY BASIC
    SOURCE: 'Lähde',
    NAME: 'Nimi',
    ROLE_IN_COMPANY: 'Rooli yrityksessä',

    // COMPANY PAGE HEADER
    CONCERN_HEADER: 'Konserni',
    PARENT_HEADER: 'Emoyhtiö',

    // COMPANY PAGE RIGHT NAV
    BASIC_INFO: 'Perustiedot',
    PERFORMER_RANKING: 'Menestyjäluokitus',
    FINANCIAL_KEYS: 'Liiketoiminnan tunnusluvut',
    REGISTRATIONS: 'Rekisteröinnit',
    COMPANY_ID_HISTORY: 'Y-tunnushistoria',
    DECIDERS: 'Päättäjät',
    MANAGEMENT_BOARD_AND_SOMETHING: 'Vastuuhenkilöt ja nimenkirjoittajat', // FIX THIS NAME
    CONCERN_COMPANIES: 'Konserniyritykset',

    // COMPANY BASIC INFO
    GROWTH_AND_PROFITABILITY: 'Kasvu ja kannattavuus',
    GROWTH: 'Kasvu',
    PROFITABILITY: 'Kannattavuus',
    ACTIVE: 'Aktiivinen',
    COMPANY_SEARCH_PLACEHOLDER: 'Hae yritystä y-tunnuksella tai nimellä',
    COMPANY: 'Yritys',
    DOWNLOAD_CONCERN_PDF: 'Lataa konsernin analyysi-PDF',
    DOWNLOAD_PDF: 'Lataa analyysi-PDF',
    DOWNLOAD_CONCERN_FINANCIAL_ANALYSIS_EXCEL: 'Vie konsernin luvut Exceliin',
    DOWNLOAD_FINANCIAL_ANALYSIS_EXCEL: 'Vie luvut Exceliin',
    DOWNLOAD_NOT_AVAILABLE: 'Yritykselle ei ole saatavilla tuotetta',
    ADD_TO_GROUP: 'Lisää ryhmään',
    FINANCIAL_ANALYSIS: 'Tilinpäätösanalyysi',
    COMPANY_CONTACT_INFO: 'Yhtiön yhteystiedot',
    COMPANY_NAME_INFO: 'Yhtiön nimitiedot',
    PRINCIPAL_COMPANY_NAMES: 'Päätoiminimi',
    PARALLEL_COMPANY_NAMES: 'Aputoiminimet',
    AUXILIARY_COMPANY_NAMES: 'Rinnakkaistoiminimet',
    PARALLEL_AUXILIARY_NAMES: 'Apusivutoiminimet',
    // These codes are provided by the Arkki database
    CNT_1: 'Päätoiminimi',
    CNT_2: 'Rinnakkaistoiminimi',
    CNT_3: 'Aputoiminimi',
    CNT_4: 'Apusivutoiminimi',
    COMPANY_NAME: 'Virallinen nimi',
    COMPANY_ID: 'Y-tunnus',
    COMPANY_ID_GRANTED: 'Y-tunnus tullut voimaan',
    INDUSTRY: 'Toimiala',
    INDUSTRY_DESCRIPTION: 'Toimialakuvaus',
    INDUSTRY_CODE: 'Toimialakoodi',
    COMPANY_STATUS: 'Yrityksen tila',
    COMPANY_DOMICILE: 'Yrityksen kotipaikka',
    COMPANY_TYPE: 'Yhtiömuoto',
    COMPANY_LANGUAGE: 'Yrityksen kieli',
    CEO: 'Toimitusjohtaja',

    STREET_ADDRESS: 'Katuosoite',
    POST_ADDRESS: 'Postiosoite',
    PHONE_NUMBER: 'Puhelin',
    WEB_ADDRESS: 'Internetosoite',

    // BOARD AFFILIATIONS
    VALID_AFFILIATIONS: 'Voimassaolevat yrityssidokset',
    LAST_CHANGE_DATE: 'Viimeisin rek.merkintä',

    // COMPANY ID HISTORY
    DATE: 'Päivämäärä',
    EVENT: 'Tapahtuma',
    OLD_NAME: 'Vanha nimi',
    NEW_NAME: 'Uusi nimi',
    PREVIOUS_NAMES: 'Edellinen nimitieto',
    TYPE: 'Tyyppi',
    BEGUN: 'Alkanut',
    ENDED: 'Päättynyt',

    // COMPANY STATUS
    COMPANY_STATUS_ACTIVE: 'Aktiivinen',
    COMPANY_STATUS_INACTIVE: 'Toiminta lakannut',
    COMPANY_STATUS_BANKRUPT: 'Konkurssi',
    COMPANY_STATUS_LIQUIDATION: 'Saneeraus',
    COMPANY_STATUS_REORGANIZATION: 'Selvitystila',
    COMPANY_STATUS_PAUSED: 'Toiminta keskeytetty',
    COMPANY_STATUS_MISSING: 'Tila puuttuu',
    COMPANY_STATUS_NO_STATEMENTS: 'ei tilikausia',

    // CONCERN COMPANIES
    CONCERN: 'Konserni',
    DAUGHTER_COMPANIES_AND_LOCATIONS: 'Tytäryhtiöt ja osakkuusyhtiöt',

    // PROTESTS
    PROTESTS: 'Protestit',
    DATE_OF_PROTEST: 'Häiriö pvm',
    PROTEST_TYPE: 'Häiriötyyppi',
    NO_PROTESTS: 'Ei protesteja viimeisen 6kk ajalta',

    // DECIDERS
    TITLE: 'Titteli',
    RESPONSIBILITIES: 'Vastuualueet',
    CHECK_DATE: 'Tarkistuspvm',
    EMAIL: 'Sähköposti',
    TELEPHONE: 'Puhelinnumero',

    // FINANCIAL BASIC
    FINANCIAL_YEAR: 'Tilikausi',
    TURNOVER: 'Liikevaihto',
    NET_PROFIT: 'Nettotulos',
    EBIT: 'Liiketoiminnan tulos',
    EBIT_PER_TURNOVER: 'Liikevoitto-%',
    EQUITY_RATIO: 'Omavaraisuusaste',
    PERSONNEL: 'Henkilöstö',

    // COMPANY INFO KEY FIGURES
    TURNOVER_KF: 'Liikevaihto',
    TURNOVER_GROWTH_PERCENT_KF: 'Liikevaihdon muutos',
    NET_PROFIT_KF: 'Nettotulos',
    AGGREGATE_EQUITY_KF: 'Oma pääoma',
    TOTAL_ASSETS_KF: 'Taseen loppusumma',
    PERSONNEL_AVERAGE_KF: 'Henkilöstömäärä',
    NO_STATEMENT_HISTORY_KF: 'Ei tilikausia saatavilla',
    INDUSTRY_KF_TITLE: 'Toimialan tunnusluvut',
    SAMPLE_SIZE: 'Otos: ',

    // KEY FIGURE GRAPHS
    KEY_FIGURES_GRAPH_TITLE: 'Tunnusluvut',
    TURNOVER_GROWTH_PERCENT_GRAPH: 'Liikevaihdon kasvu-%',
    RETURN_ON_INVESTMENT_GRAPH: 'Sijoitetun pääoman tuotto-%',
    NET_PROFIT_PER_TURNOVER_GRAPH: 'Nettotulos-%',
    EQUITY_RATIO_GRAPH: 'Omavaraisuusaste',
    CURRENT_RATIO_GRAPH: 'Current ratio',
    TURNOVER_GRAPH: 'Normeerattu liikevaihto',
    NET_PROFIT_GRAPH: 'Nettotulos',

    TURNOVER_GROWTH_PERCENT_EXPLANATION_GRAPH: 'Kasvu %',
    RETURN_ON_INVESTMENT_EXPLANATION_GRAPH: 'Kannattavuus',
    NET_PROFIT_PER_TURNOVER_EXPLANATION_GRAPH: 'Tulos %',
    CURRENT_RATIO_EXPLANATION_GRAPH: 'Maksuvalmius',
    EQUITY_RATIO_EXPLANATION_GRAPH: 'Vakavaraisuus',
    TURNOVER_EXPLANATION_GRAPH: 'Liikevaihto €',
    NET_PROFIT_EXPLANATION_GRAPH: 'Nettotulos €',

    COMPARE: 'Vertaa',
    CHOOSE_COMPARE_COMPANY: 'Valitse vertailtava yritys',
    SEARCH_COMPARE_COMPANY: 'Hae vertailtavaa yritystä',
    COMPARE_NO_STATEMENTS: 'Vertailuyrityksestä ei ole saatavilla tilikausia',
    COMPARE_LATEST_STATEMENT: 'Vertailuyrityksen viimeisin tilikausi',
    GRAPH_INFO_SINGLE_COMPANY:
        'Graafissa esitetään valittu tunnusluku yrityksen viimeiseltä 10 tilikaudelta kohdistusvuosittain. ' +
        'Voit vaihtaa graafissa esitettävää tunnuslukua alasvetovalikosta oikeassa reunassa.',

    // COMPARE GRAPH MODAL
    COMPARE_GRAPH_MODAL_TITLE: 'Vertaile',
    CHOOSE_COMPARE_TARGET: 'Valitse vertailun kohde',
    CHOOSE_COMPANY: 'Valitse yritys',
    SEARCH_BY_NAME_OR_BUSINESS_ID: 'Hae nimellä tai y-tunnuksella',
    GROUP: 'Ryhmä',

    // MANAGEMENT BOARD
    DATE_OF_BIRTH: 'Syntymäaika',
    NATIONALITY: 'Kansalaisuus',
    LAST_MODIFIED: 'Viim. merk.',
    BOARD: 'Hallitus',
    COMPANY_SIGNATORY: 'Yhtiön nimenkirjoituslauseke: ',
    PERSON_SIGNATORY: 'Nimenkirjoitustapa: ',
    OTHER_MANAGEMENT: 'Muu johto',
    SIGNATORY_GROUP_MEMBERS: 'Nimenkirjoittajat',
    AUDITORS: 'Tilintarkastajat',

    // PERFORMER RANKING
    NOTE_ON_PARENT_COMPANY:
        'Luokituksen tulkinnassa on huomioitava, että yrityksen emoyhtiö on',
    PERFORMER_RANKING_DESCRIPTION:
        'Menestyjäluokitus kuvaa yrityksen liiketaloudellista menestystä suhteessa muihin yrityksiin asteikolla 0-100 (tähditys samassa suhteessa).',
    PERFORMER_RANKING_POINTS_DESCRIPTION:
        'Menestyjä-yrityksen pisteraja on 50. Yrityksellä on kohonnut rahoituksellinen riski, kun pisteet alittavat 30 pistettä.',
    PERFORMER_RANKING_HELP: 'Menestyjä-luokituksen tulkintaan löydät apua ',
    PERFORMER_RANKING_HELP_LINK: 'Tunnuslukuoppaastamme',
    RISK_CLASS: 'Riskiluokitus',
    RISK_CLASS_DESCRIPTION:
        'Riskiluokitus on tilastollisesti mallinnettu. Kolmiportainen liikennevaloluokitus ennakoi yrityksen riskiä saada maksuhäiriömerkintä vuoden sisällä kyselyhetkestä.',
    TRAFFIC_LIGHT_DESCRIPTION:
        'Vihreän valon yrityksistä mallin mukaisesti maksuhäiriömerkinnän saa vuoden sisällä vain noin promille yrityksistä. Keltainen valo indikoi lisäselvitysten tarvetta ja punainen valo merkittävää yritykseen kohdistuvaa rahoitusriskiä.',
    NOT_AVAILABLE: 'Ei saatavilla',
    // REGISTRATIONS
    REGISTER: 'Rekisteri',
    BEGIN: 'Alkaen',
    END: 'Päättyen',
    COMPANY_ID_GRANTED_REGISTER: 'Yritys- ja yhteisötietojärjestelmä',
    PREPAYMENT_REGISTER: 'Ennakkoperintärekisteri',
    PREPAYMENT_REGISTER_NEXT_REVISION:
        'Ennakkoperintärekisterin tarkistuspäivä',
    EMPLOYER_REGISTER: 'Työnantajarekisteri',
    TAX_ADMINISTRATION_REGISTER: 'Verohallinnon perustiedot',
    TRADE_REGISTER: 'Kaupparekisteri',
    VAT_REGISTER: 'Arvonlisäverovelvollisuusrekisteri',
    VAT_REGISTER_DESCRIPTION: 'Liiketoiminnasta',
    VAT_REGISTER_REAL_ESTATE_LIABILITY_DESCRIPTION:
        'Kiinteistön käyttöoikeuden luovuttamisesta',
    IN_REGISTER: 'Rekisterissä',
    NOT_IN_REGISTER: 'Ei rekisteröintiä',

    // GROUP PAGE
    CONFIRM_DELETE_BUSINESS: 'Poistetaanko yritys ryhmästä?',
    DELETE_BUSINESS_SUCCESS: 'Yrityksen poisto onnistui',
    DELETE_BUSINESS_FAIL: 'Yrityksen poisto epäonnistui',
    GROUPS_COMPANIES: 'Ryhmän yritykset',
    GROUPS_KEYFIGURES: 'Ryhmän tunnusluvut',
    EDIT_GROUP: 'Muokkaa ryhmää',

    // FINANCIAL ANALYSIS
    KEYS: 'Tunnusluvut',
    INCOME_STATEMENT: 'Tuloslaskelma',
    BALANCE_ASSETS: 'Tase vastaavaa',
    BALANCE_LIABILITIES: 'Tase vastattavaa',
    CASH_FLOW_STATEMENT: 'Kassavirtalaskelma',

    // FINANCIAL ANALYSIS TABLE KEYS
    TABLE_KEYS: {
        keys: {
            statementLength: {
                statementLength: 'Tilikauden pituus (kk)'
            },
            scopeOfActivities: {
                title: 'Toiminnanlaajuus',
                turnover: 'Liikevaihto (€)',
                turnoverGrowthPercent: 'Liikevaihdon kasvuprosentti (%)',
                grossProfit: 'Bruttotulos (€)',
                growthInGrossProfitPercentage:
                    'Bruttotuloksen kasvuprosentti (%)',
                investmentExpensesCashFlow: 'Investoinnit (€)',
                totalAssets: 'Vastaavaa yhteensä (€)',
                personnelAverage: 'Henkilökunta keskimäärin (henk.)'
            },
            profitability: {
                title: 'Kannattavuus',
                ebitda: 'Käyttökate (€)',
                ebit: 'Liiketulos (€)',
                netProfitBeforeDepreciation: 'Rahoitustulos (€)',
                netProfit: 'Nettotulos (€)'
            },
            capitalAndRevenue: {
                title: 'Pääoma ja sen tuotto',
                turnoverRateOfCapital: 'Pääoman kiertonopeus (vuotta)',
                investedCapital: 'Sijoitettu pääoma (keskimäärin) (€)',
                interestBearingDebt: 'Korolliset velat (€)',
                bookValue: 'Tasesubstanssi (€)',
                calculusEva: 'Taloudellinen lisäarvo (EVA) (€)',
                calculusWacc: 'Painotettu pääoman kustannus (WACC) (%)',
                returnOnInvestmentPercent: 'Sijoitetun pääoman tuotto (%)',
                returnOnAssetsPercent: 'Koko pääoman tuotto (%)',
                returnOnEquityPercent: 'Oman pääoman tuotto (%)'
            },
            adequacyOfFunding: {
                title: 'Rahoituksen riittävyys',
                netInterestIncome: 'Korkokate (€)',
                netFinancialExpensesPerEbitda:
                    'Nettorahoituskulut / Käyttökate (%)',
                netFinancialExpensesPerOperatingIncomePercent:
                    'Nettorahoituskulut / liikevaihto (%)',
                liabilityPaybackTime:
                    'Vieraan pääoman takaisinmaksuaika (vuotta)'
            },
            rahoituksenrakenne: {
                title: 'Rahoituksen rakenne',
                equityRatio: 'Omavaraisuusaste (%)',
                gearing: 'Gearing (%)',
                debtEquityRatio: 'Velkaantumisaste (%)',
                netDebtEquityRatio: 'Nettovelkaantumisaste (%)',
                relativeIndebtedness: 'Suhteellinen velkaantuneisuus (%)',
                interestPerTurnoverPercent: 'Korkorasite (%)',
                interestPerInterestBearingDebt:
                    'Korkokulut / korolliset velat (%)'
            },
            workingCapitalAndRotationTimes: {
                title: 'Käyttöpääoma ja käyttöpääomien kiertoajat',
                workingCapital: 'Käyttöpääoma (€)',
                netWorkingCapital: 'Nettokäyttöpääoma (€)',
                salesReceivableTurnoverTime: 'Myyntisaamisten kiertoaika (vrk)',
                accountsPayableTurnoverTime: 'Ostovelkojen kiertoaika (vrk)',
                materialAndSupplyInventoryTurnoverTime:
                    'Ainevarastojen kiertoaika (vrk)',
                finishedGoodsInventoryTurnoverTime:
                    'Valmistevaraston kiertoaika (vrk)',
                currentAssetsTurnoverTime:
                    'Koko vaihto-omaisuuden kiertoaika (vrk)',
                currentAssetsPerTurnoverPercent:
                    'Vaihto-omaisuus / liikevaihto (%)'
            },
            liquidity: {
                title: 'Maksuvalmius',
                quickRatio: 'Quick ratio',
                currentRatio: 'Current ratio'
            },
            efficiencyKeyFigures: {
                title: 'Tehokkuustunnuslukuja',
                turnoverPerEmployee: 'Liikevaihto / henkilö (€)',
                valueAddedPerEmployee: 'Jalostusarvo / henkilö (€)',
                personnelExpensePerEmployee: 'Henkilöstökulut / henkilö (€)',
                ebitdaPerEmployee: 'Käyttökate / henkilö (€)',
                ebitPerEmployee: 'Liiketulos / henkilö (€)',
                netProfitPerEmployee: 'Nettotulos / henkilö (€)',
                valueAddedPerPersonnelExpense:
                    'Työn reaalituottavuus (jalostusarvo / palkat) (%)'
            },
            otherKeyFigures: {
                title: 'Muita tunnuslukuja',
                valueAddedPerTurnover: 'Jalostusarvo / liikevaihto (%)',
                exportPerTurnover: 'Vienti / liikevaihto (%)',
                performerRankingPoints: 'Menestyjäpisteet'
            }
        },
        profitAndLossAccount: {
            profitAndLossAccount: {
                title: 'Tuloslaskelma',
                turnover: 'Liikevaihto (€)',
                finishedGoodsIncrease: '+ Valmistevaraston lisäys (€)',
                otherOperatingIncome: '+ Liiketoiminnan muut tuotot (€)',
                associatedCompanyOperatingIncome:
                    '+ Osuus osakkuusyhtiöiden tuloksesta (€)',
                rawMaterialsUse: '– Ainekäyttö (€)',
                externalServices: '- Ulkopuoliset palvelut (€)',
                grossProfit: '– Bruttotulos (€)',
                personnelExpenses: '- Henkilöstökulut (€)',
                otherOperatingExpense: '- Liiketoiminnan muut kulut (€)',

                ebitda: 'Käyttökate (€)',
                adjustedDepreciation: '– Suunnitelman mukaiset poistot (€)',
                amortization: '– Arvonalentumiset (€)',

                ebit: 'Liiketulos (€)',
                dividendIncome: '+ Osinkotuotot (€)',
                otherInterestAndFinancialIncome:
                    '+ Muut korko- ja rahoitustuotot (€)',
                exchangeRateDifferenceEffects:
                    '+ Kirjatut valuuttakurssierot (€)',
                otherInterestAndFinancialExpense:
                    '- Korko- ja muut rahoituskulut (€)',
                depreciationInInvestments:
                    '– Sijoitusten ja arvopapereiden arvonalentumiset (€)',
                associatedCompanyFinancialTranches:
                    '+ Osuus osakkuusyhtiöiden tuloksesta (€)',
                directTaxes: '– Välittömät verot (€)',

                netProfit: 'Nettotulos (€)',
                extraordinaryIncome: '+ Satunnaiset tuotot (€)',
                extraordinaryExpense: '– Satunnaiset kulut (€)',
                extraordinaryAssociatedCompanyIncomeAndExpense:
                    '+ Satunnainen osakkuusyhtiötulos (€)',
                netGroupSupport: '– Konserniavustukset (€)',

                totalProfit: 'Kokonaistulos (€)',
                growthInUntaxedReserves: '– Vapaaehtoisten varausten kasvu (€)',
                depreciationDifference: '- Poistoerot (€)',
                otherAdjustmentItems: '– Muut oikaisuerät (€)',
                minorityShareFromProfit: '– Vähemmistön osuus tuloksesta (€)',

                bookResult: 'Kirjanpidon tulos (€)'
            }
        },
        balanceAssets: {
            fixedAssets: {
                title: 'Pysyvät vastaavat'
            },
            intangibleAssets: {
                title: 'Aineettomat hyödykkeet',
                startupAndResearchDevelopmentExpenses:
                    'Perustamis- ja tutkimusmenot (€)',
                goodwill: 'Liikearvot (€)',
                otherIntangibleAssets: 'Muut aineettomat hyödykkeet (€)',
                aggregateIntangibleAssets: 'Aineettomat hyödykkeet yhteensä (€)'
            },
            tangibleAssets: {
                title: 'Aineelliset hyödykkeet',
                landAndWaterProperty: 'Maa- ja vesialueet (€)',
                buildings: 'Rakennukset ja rakennelmat (€)',
                machineryAndEquipment: 'Koneet ja kalusto (€)',
                otherTangibleAssets: 'Muut aineelliset hyödykkeet (€)',
                advancePaymentsAndAcquisitionsInProcess:
                    'Keskeneräiset työt (€)',
                aggregateTangibleAssets: 'Aineelliset hyödykkeet yhteensä (€)'
            },
            longtermInvestments: {
                title: 'Pitkäaikaiset sijoitukset',
                stakesInGroupCompanies: 'Sisäiset osakkeet ja osuudet (€)',
                otherStakesAndShares: 'Muut osakkeet ja osuudet (€)',
                internalReceivables: 'Sisäiset saamiset (€)',
                otherReceivablesAndInvestments: 'Muut saamiset (€)',
                aggregateLongTermInvestments:
                    'Pitkäaikaiset sijoitukset yhteensä (€)',
                offBalanceSheetAssets: 'Taseen ulkopuoliset vastuut (€)',
                valuationItemsAndDepreciationDifference:
                    'Arvostuserät ja poistoero (€)'
            },
            currentAssets: {
                title: 'Vaihtuvat vastaavat'
            },
            stocks: {
                title: 'Vaihto-omaisuus',
                materialsAndSupplies: 'Aineet ja tarvikkeet (€)',
                incompleteProducts: 'Keskeneräiset tuotteet (€)',
                finishedGoods: 'Valmiit tuotteet / tavarat (€)',
                otherCurrentAssets: 'Muu vaihto-omaisuus (€)',
                aggregateCurrentAssets: 'Vaihto-omaisuus yhteensä (€)'
            },
            longtermReceivables: {
                title: 'Pitkäaikaiset saamiset',
                longTermSalesReceivable: 'Pitkäaikaiset myyntisaamiset (€)',
                longTermOutstandingLoans: 'Pitkäaikaiset lainasaamiset (€)',
                otherLongTermReceivables: 'Pitkäaikaiset muut saamiset (€)',
                aggregateLongTermReceivables:
                    'Pitkäaikaiset saamiset yhteensä (€)'
            },
            shorttermReceivables: {
                title: 'Lyhytaikaiset saamiset',
                shortTermSalesReceivable: 'Lyhytaikaiset myyntisaamiset (€)',
                adjustingEntriesAndAccruedIncome: 'Siirtosaamiset (€)',
                outstandingLoans: 'Lainasaamiset (€)',
                otherShortTermReceivables: 'Lyhytaikaiset muut saamiset (€)',
                aggregateShortTermReceivables:
                    'Lyhytaikaiset saamiset yhteensä (€)',

                financialAssetsAndSecurities:
                    'Rahoitusomaisuus arvopaperit (€)',
                cashAndCashEquivalents: 'Rahat ja pankkisaamiset (€)',
                totalAssets: 'Vastaavaa yhteensä (€)'
            }
        },
        balanceLiabilities: {
            capitalAndReserves: {
                title: 'Oma pääoma',
                shareCapital: 'Osakepääoma (€)',
                sharePremiumAccount: 'Ylikurssirahasto (€)',
                revaluationReserve: 'Arvonkorotusrahasto (€)',
                otherReserves: 'Muut rahastot (€)',
                otherRestrictedEquity: 'Muu sidottu oma pääoma (€)',
                resultFromPreviousFinancialYear:
                    'Edellisten tilikausien voitto / tappio (€)',
                bookResultInBalanceSheet: 'Tilikauden voitto / tappio (€)',
                aggregateEquity: 'Oma pääoma yhteensä (€)',

                equityConditionedLoan: 'Pääomalainat (€)',
                equityAdjustment: 'Oman pääoman oikaisu (€)',
                aggregateOtherEquityLikeItems:
                    'Muut pääoman luonteiset erät (€)'
            },
            accumulatedAppropriations: {
                title: 'Tilinpäätössiirtojen kertymä',

                accumulatedDepreciationDifference: 'Kertynyt poistoero (€)',
                aggregateUntaxedReserves: 'Vapaaehtoiset varaukset (€)',
                otherUnspecifiedAccumulatedFinancialStatementTransfers:
                    'Erittelemätön tilinpäätössiirtokertymä (€)',
                aggregateFinancialStatementTransfers:
                    'Tilinpäätössiirrot yhteensä (€)',
                mandatoryProvisionReserves: 'Pakolliset varaukset yhteensä (€)',
                offBalanceSheetLiabilities: 'Taseen ulkopuoliset vastuut (€)',
                deferredTaxLiabilities: 'Laskennallinen verovelka (€)'
            },
            creditors: {
                title: 'Vieras pääoma'
            },
            longtermLiabilities: {
                title: 'Pitkäaikaiset velat',
                bonds: 'Joukkovelkakirjalainat (€)',
                convertibleBonds: 'Vaihtovelkakirjalainat (€)',
                longTermLoansFromFinancialInstitutions:
                    'Pitkäaikaiset lainat rahoituslaitoksilta (€)',
                pensionLoans: 'Eläkelainat (€)',
                longTermReceivedAdvancePayments: 'Saadut ennakot (€)',
                longTermAccountsPayable: 'Pitkäaikaiset ostovelat (€)',
                otherLongTermLiabilities: 'Muut pitkäaikaiset velat (€)',
                aggregateLongTermLiabilities: 'Pitkäaikaiset velat yhteensä (€)'
            },
            shorttermLiabilities: {
                title: 'Lyhytaikaiset velat',
                shortTermLoansFromFinancialInstitutions:
                    'Lainat rahoituslaitoksilta (€)',
                shortTermPensionFunds: 'Lyhytaikaiset eläkelainat (€)',
                shortTermReceivedAdvancePayments:
                    'Tilauksista saadut ennakot (€)',
                shortTermAccountsPayable: 'Ostovelat (€)',
                shortTermAccruedLiabilities: 'Siirtovelat (€)',
                notesPayable: 'Rahoitusvekselit (€)',
                otherShortTermLiabilities: 'Muut lyhytaikaiset velat (€)',
                aggregateShortTermLiabilities:
                    'Lyhytaikaiset velat yhteensä (€)',
                totalAssetsAndLiabilities: 'Vastattavaa yhteensä (€)'
            }
        },
        cashFlowStatement: {
            cashFlowStatement: {
                title: 'Kassavirta',
                turnover: 'Liikevaihto (€)',
                growthInSalesReceivable: '- Myyntisaamisten kasvu (€)',
                growthInPercentageOfCompletionEntries:
                    '– Osatuloutussaamisten kasvu (€)',
                growthInReceivedAdvancePayments:
                    '+ Saatujen ennakkomaksujen kasvu (€)',

                cashIncomeOfSales: 'Myynnin kassatulot (€)',
                otherOperatingIncomeCashFlow:
                    '+ Liiketoiminnan muut tuotot (€)',
                materialPurchases: '- Aineostot (€)',
                growthInAccountsPayable: '+ Ostovelkojen kasvu (€)',
                increaseInAdvancePayments: '– Ennakkomaksujen lisäys (€)',
                personnelExpensesCashFlow: '– Henkilöstökulut (€)',
                externalServices: '- Ulkopuoliset palvelut (€)',
                aggregateOtherShortTermExpenses:
                    '– Muut lyhytvaikutteiset kulut yhteensä (€)',
                increaseInTransferringItems: '+ Siirtyvien erien lisäys (€)',
                increaseInMandatoryProvisionReserves:
                    '+ Pakollisten varausten lisäys (€)',
                manufacturingForOwnUseCashFlow:
                    '+ Valmistus omaan käyttöön (€)',

                cashFlowOperatingActivities: 'Toimintajäämä (€)',
                financialIncomeCashFlow: '+ Rahoitustuotot (€)',
                financialExpenseCashFlow: '– Rahoituskulut (€)',
                taxCashFlow: '– Verot (€)',
                dividendCashFlow: '– Osingot (€)',
                netGroupSupport: '+ Konserniavustukset (€)',
                netExtraordinaryIncomeCashFlow:
                    '+ Satunnaiset tuotot - kulut (€)',

                cashFlowOperatingAndFinancialActivities: 'Rahoitusjäämä (€)',
                investmentExpensesCashFlow: '- Investoinnit (€)',
                increaseInInvestmentsAndLongTermReceivablesCashFlow:
                    '– Sijoitusten ja pitkäaik. saamisten muutos (€)',
                unspecifiedInvestmentsCashFlow:
                    '– Erittelemättömät investoinnit (€)',

                cashFlowOperatingAndFinancialAndInvestmentActivities:
                    'Investointijäämä (€)',
                increaseInLongTermLiabilities:
                    '+ Pitkäaikaisen vieraan pääoman lisäys (€)',
                increaseInShortTermLiabilities:
                    '+ Lyhytaikaisen vieraan pääoman lisäys (€)',
                increaseInEquityConditionedLoans: '+ Pääomalainojen lisäys (€)',
                increaseInEquity: '+ Oman pääoman lisäys (€)',
                increaseInCashAssets: '+ Rahavarojen lisäys (€)',
                increaseInOtherShortTermReceivables:
                    '+ Muiden lyhytaikaisten saamisten lisäys (€)',
                adjustmentItemsCashFlow: '+ Oikaisuerät (€)',
                cashFlowStatementSmoothing: 'Kassalaskelman tasaus (€)'
            },
            keyFiguresBasedOnCashFlow: {
                title: 'Kassavirtapohjaisia lukuja',
                financialExpenseMargin: 'Rahoituskulujen hoitokate (€)',
                internalFinancingOfInvestments:
                    'Investointien tulorahoitus (€)',
                liabilityPaybackPeriod:
                    'Vieraan pääoman takaisinmaksuaika (kassavirta) (€)'
            }
        }
    },

    // GROUP-LIST PAGE
    CATEGORY_NAME: 'Kategorian nimi',
    GROUP_NAME: 'Ryhmän nimi',
    AMOUNT_COMPANIES: 'Yrityksiä',
    TARGET_YEAR: 'Kohdistusvuosi',
    GROWTH_PERCENTAGE: 'Kasvu',
    NET_PROFIT_PER_TURNOVER: 'Tulos',
    FAILED_TO_LOAD_GROUPS: 'Ryhmien lataamisessa virhe',
    GROUPS_TITLE: 'Ryhmät',
    CREATE_NEW_GROUP: 'Luo uusi ryhmä',
    NO_GROUPS: 'Sinulla ei ole vielä ryhmiä. Aloita luomalla ryhmä.',

    // CREATE GROUP MODAL
    CREATE_GROUP_MODAL_TITLE: 'Luo ryhmä',
    GROUP_CREATE_SUCCESS: 'Uusi ryhmä luotiin onnistuneesti.',
    GROUP_CREATE_FAIL:
        'Ryhmän luominen epäonnistui. Ole hyvä ja yritä myöhemmin uudelleen.',
    EMPTY_NAME_ERROR: 'Nimi ei voi olla tyhjä',
    INVALID_NAME_ERROR:
        'Sallitut merkit ovat kirjaimet, numerot, välilyönnit sekä ala- ja väliviivat.',
    CANCEL_MODAL: 'Peruuta',
    CREATE_GROUP: 'Luo ryhmä',
    SELECT_CATEGORY: 'Ylätason ryhmä (valinnainen)',
    GROUP_CATEGORY: 'Ylätason ryhmä',
    CATEGORY_CREATE_SUCCESS: 'Uusi ylätason ryhmä luotiin onnistuneesti.',
    CATEGORY_CREATE_FAIL:
        'Ylätason ryhmän luominen epäonnistui. Ole hyvä ja yritä myöhemmin uudelleen.',
    CATEGORY_NAME_LABEL: 'Ylätason ryhmän nimi',
    CREATE_NEW_CATEGORY_OPTION: 'Luo uusi ylätason ryhmä',
    CREATE_SUB_GROUP: 'Luo alaryhmä',

    // GROUP & CATEGORY DELETE MODALS
    DELETE_CATEGORY_MODAL_TITLE: 'Poista ylätason ryhmä',
    DELETE_CATEGORY_CONFIRM: 'Haluatko varmasti poistaa ylätason ryhmän',
    DELETE_CATEGORY_INFO_PART1: 'Hyväksymällä poistat myös',
    DELETE_CATEGORY_INFO_PART2: 'kpl alaryhmiä.',
    DELETE_CATEGORY: 'Poista ylätason ryhmä',
    CATEGORY_DELETE_SUCCESS: 'Ylätason ryhmä poistettiin onnistuneesti.',
    CATEGORY_DELETE_FAIL:
        'Ylätason ryhmän poistaminen epäonnistui. Ole hyvä ja yritä myöhemmin uudelleen.',

    DELETE_GROUP_MODAL_TITLE: 'Poista ryhmä',
    DELETE_GROUP_CONFIRM: 'Haluatko varmasti poistaa ryhmän',
    DELETE_GROUP: 'Poista ryhmä',
    GROUP_DELETE_SUCCESS: 'Ryhmä poistettiin onnistuneesti.',
    GROUP_DELETE_FAIL:
        'Ryhmän poistaminen epäonnistui. Ole hyvä ja yritä myöhemmin uudelleen.',

    // RENAME MODAL
    RENAME_GROUP_MODAL_TITLE: 'Nimeä ryhmä uudelleen',
    RENAME_GROUP_LABEL: 'Ryhmän uusi nimi',
    RENAME_CONFIRMATION: 'Nimeä uudelleen',
    RENAME_GROUP: 'Nimeä uudelleen',
    GROUP_RENAME_SUCCESS: 'Ryhmä nimettiin uudelleen onnistuneesti',
    GROUP_RENAME_FAIL:
        'Ryhmän uudelleen nimeäminen epäonnistui. Ole hyvä ja yritä myöhemmin uudelleen.',

    // ADD COMPANY TO GROUP MODAL
    VALIDATION_ERROR_MESSAGE: 'Virheilmoitus',
    ADD: 'Lisää',
    GROUP_BEFORE_ADDITION_WARNING: 'Valitse ryhmä ennen lisäystä',
    ADDITION_SUCCESSFUL: 'Lisäys onnistui',
    ADDITION_FAILURE: 'Lisäys epäonnistui',
    ADDITION_GROUP: 'Ryhmä johon yritykset lisätään',
    ADDITION_GROUP_SINGLE_COMPANY: 'Ryhmä johon yritys lisätään',
    CHOOSE_GROUP: 'Valitse ryhmä',
    LOAD_CSV: 'Lataa Y-tunnukset CSV-tiedostona',
    NO_COMPANIES_ADDED: 'Yrityksiä ei lisätty',
    ADD_COMPANY_TO_GROUP_TITLE: 'Lisää yrityksiä ryhmiin',
    ADD_COMPANY_TO_GROUP: 'Lisää yritys ryhmään',
    ERROR_UPLOADING_FILE: 'Virhe tiedoston latauksessa',
    ADDITION_FAILURE_TRY_AGAIN:
        'Yrityksen lisäyksessä tapahtui virhe. Huomioithan, että ryhmässä voi olla korkeintaan 4000 yritystä. Ole hyvä ja yritä myöhemmin uudelleen.',
    ADD_COMPANIES: 'Lisää yrityksiä',
    NO_BUSINESS_ID_ERROR: 'Ei y-tunnusta, lisäystä ei voi suorittaa',

    // DELETE GROUP'S COMPANIES
    DELETE_ALL_COMPANIES_MODAL_TITLE: 'Poista ryhmän yritykset',
    DELETE_COMPANIES_IN_GROUP: 'Poista ryhmän yritykset',
    DELETE_COMPANIES: 'Poista yritykset',
    DELETE_ALL_COMPANIES_CONFIRM:
        'Haluatko varmasti poistaa kaikki yritykset ryhmästä',
    DELETE_ALL_COMPANIES_INFO_PART1: 'Hyväksymällä poistat',
    DELETE_ALL_COMPANIES_INFO_PART2: 'kpl yrityksiä.',
    DELETE_ALL_COMPANIES_SUCCESS: 'Ryhmän yritykset poistettiin onnistuneesti.',
    DELETE_ALL_COMPANIES_FAIL:
        'Ryhmän yritysten poisto epäonnistui. Ole hyvä ja yritä myöhemmin uudelleen.',

    // ERROR
    LOGIN_ERROR_500:
        'Kirjautuminen epäonnistui, ota yhteyttä asiakaspalveluun.',
    LOGIN_ERROR_401: 'Virheellinen käyttäjätunnus tai salasana.',
    LOGIN_ERROR_403:
        'Käyttäjätunnuksellasi ei ole käyttöoikeutta Analysaattoriin',
    LOGIN_ERROR_EMPTY: 'Täytä käyttäjätunnus ja salasana.',
    API_ERROR_OCCURRED: 'Tietoa haettaessa tapahtui virhe',
    LOGIN_ERROR_PASSWORD_EXPIRED: 'Salasanasi on vanhentunut',
    LOGIN_ERROR_UNDEFINED:
        'Sisäänkirjautuessa tapahtui määrittelemätön virhe. Ota yhteyttä asiakaspalveluun',
    ERROR: 'Tapahtui virhe',

    // LINKS
    LINK_TO_ORIGINAL_NEWS_ITEM: 'Linkki alkuperäiseen artikkeliin',

    APPOINTMENT_NEWS: 'Nimitysuutinen',
    COMPANIES_AFFILIATED_WITH_THE_PUBLICATION: 'Uutiseen liittyvät yritykset',

    // VALIDATION
    BUSINESS_ID_NOT_VALID: 'Virheellinen y-tunnus',
    ALREADY_ADDED_TO_GROUP: 'Yritys on jo ryhmässä',
    COMPANY_NOT_FOUND: 'Yritystä ei löydy',

    // SEARCH PAGE
    SELECT: 'Poimi',
    SEARCH_FROM_GROUP: 'Kohdista ryhmään',
    COMPANY_BASIC_INFO: 'Yrityksen perustiedot',
    LOAD_EXCEL: 'Lataa excel',
    OPEN_PREVIEW: 'Poimi yritykset',
    PREVIEW: 'Poimittu yritysjoukko',
    LOADING_EXCEL: 'Ladataan Exceliä',
    CHOOSE_COMPANY_STATE: 'Valitse yrityksen tila',
    CHOOSE: 'Valitse',
    ADDRESS_CITY: 'Sijaintikunta',
    DOMICILE: 'Kotipaikka',
    DOMICILE_INFO:
        'Kotipaikka on yrityksen virallinen YTJ:ään ilmoittama kotipaikka.',
    LOCATION_MUNICIPALITY: 'Maakunta/kaupunki',
    LOCATION_MUNICIPALITY_INFO:
        'Maakunta ja kaupunki haetaan yrityksen käyntiosoitteen perusteella.',
    ONLY_NUMBERS_ALLOWED: 'Vain numerot sallittuja',
    LOWER_VALUE_GREATER_ERROR: 'Alempi arvo ei voi olla suurempi kuin ylempi',
    FILL_BOTH_VALUES: 'Syötä molemmat arvot',
    VALUE_BEYOND_LIMITS: 'Liian suuri arvo',
    PERSONNEL_AVERAGE: 'Henkilökunta keskimäärin',
    PERSONNEL_EXPENSES: 'Henkilöstökulut',
    RAW_MATERIALS_USE: 'Ainekäyttö',
    AGGREGATE_CURRENT_ASSETS: 'Vaihto-omaisuus',
    BUILDINGS: 'Rakennukset ja rakennelmat',
    COMPANY_ID_GRANTED_START: 'Y-tunnus tullut voimaan, alkaen',
    COMPANY_ID_GRANTED_END: 'Y-tunnus tullut voimaan, päättyen',
    STARTDATE_AFTER_ENDDATE: 'Alkupäivämäärä loppupäivämäärän jälkeen',
    FOCUS: 'Kohdista',
    PICK_INTRODUCTION:
        'Voit poimia yritysjoukon rajaamalla yrityksiä toimialan, yrityksen perustietojen tai taloudellisten tunnuslukujen mukaan, tai voit tehdä poiminnan omasta ryhmästäsi. ' +
        'Voit poimia enintään 4000 yritystä kerralla. ' +
        'Syötä haluamasi arvot, joiden perusteella poiminta tehdään. ' +
        'Poiminta kohdistuu oletuksena tuoreimpaan yrityksestä saatavilla olevaan analysoituun tilikauteen. ' +
        'Mikäli haluat poiminnan pidemmällä aikasarjalla tai laajemmilla tiedoilla, ole yhteydessä Alma Talent Tietopalveluiden asiakaspalveluun.',
    BUSINESS_IDS: 'Y-tunnukset',
    SEARCH_NOTIFICATION_CREATING: 'Poimintaa luodaan',
    SEARCH_NOTIFICATION_CREATING_DESCRIPTION:
        'Poimintaa luodaan. Luomisessa voi mennä hetki.',
    SEARCH_NOTIFICATION_MAX_ERROR:
        'Poiminnan maksimi määrä on 4000 y-tunnusta. Tarkenna hakuehtoja',
    SEARCH_NOTIFICATION_SUCCESS: 'Poiminta valmis.',
    SEARCH_NOTIFICATION_SUCCESS_DESCRIPTION:
        'Poiminta valmis. Excelin lataus onnistui.',
    SEARCH_NOTIFICATION_ERROR:
        'Poiminnan latauksessa tapahtui virhe. Ota yhteyttä asiakaspalveluun.',
    ONLY_NUMBERS_MINUS_ALLOWED: 'Vain numerot ja miinus-merkki sallittuja',
    LOW_RISK: 'Vähäinen riski',
    MEDIUM_RISK: 'Vaaditaan lisäselvityksiä',
    HIGH_RISK: 'Merkittävä riski',

    // PICK POPOVERS
    PICK_INTRODUCTION_POPOVER:
        'Y-tunnusten ilmoitettu lukumäärä voi poiketa excelissä olevien rivien määrästä. ' +
        'Mikäli poiminnassa on mukana konserniyrityksiä, emo ja konserni ilmoitetaan poiminnassa yhtenä y-tunnuksena mutta excelissä emo ja konserni ovat omilla riveillään.',
    TURNOVER_POPOVER:
        'Liikevaihto kuvaa varsinaisen toiminnan myyntituottoja alennusten ja arvonlisäveron jälkeen. ',
    EBIT_PER_TURNOVER_POPOVER:
        'Liiketulos on virallisen tuloslaskelman ensimmäinen välitulos, joka kertoo, kuinka paljon varsinaisen liiketoiminnan tuotoista on jäänyt jäljellä ennen rahoituseriä ja veroja. ',
    NET_PROFIT_POPOVER:
        'Nettotulosta pidetään yrityksen varsinaisen toiminnan tuloksena. ',
    PERSONNEL_AVERAGE_POPOVER:
        'Henkilöstömäärä ilmoitetaan vuotuisena keskiarvolukuna. Luku kertoo pääsääntöisesti yrityksen kokopäivätyöllisten määrän. ',
    PERSONNEL_EXPENSES_POPOVER:
        'Tunnusluku kertoo yrityksen henkilöstöönsä käyttämät palkka-, palkkio-, eläke-, ja henkilöstösivukulut. ',
    RAW_MATERIALS_USE_POPOVER:
        'Ainekäyttö on aine- ja tavaraostot vähennetty/lisätty varaston muutos. Tunnuslukuun vaikuttaa varaston arvon määrä eli mikäli varastoa kasvatetaan ainekäyttö vähenee ja kun varasto pienenee, niin ainekäyttö lisääntyy.',
    AGGREGATE_CURRENT_ASSETS_POPOVER:
        'Vaihto-omaisuutta ovat sellaisinaan tai jalostettuina luovutettaviksi tai kulutettaviksi tarkoitetut yrityksen omistamat hyödykkeet.',
    BUILDINGS_POPOVER: 'Yrityksen omistamat rakennukset ja rakennelmat.',

    // PICK TO GROUP
    PICK_TO_GROUP: 'Lisää yritykset ryhmään',
    PICK_READY: 'Valmis',
    ADD_PICK_TO_GROUP: 'Lisää olemassa olevaan ryhmään',
    ADD_PICK_TO_NEW_GROUP: 'Lisää uuteen ryhmään',
    NEW_GROUP_NAME: 'Kirjoita ryhmän nimi',
    NO_COMPANIES_TO_ADD: 'Ryhmä sisältää jo poimitut yritykset.',
    NOT_ALL_COMPANIES_WERE_ADDED:
        'Osaa yrityksistä ei voitu lisätä ryhmään. Yritys on jo ryhmässä.',
    CANCEL: 'Peruuta'
};
